import React, { useState, useEffect } from "react";
import { Modal, Toast, ToastContainer, Form  } from 'react-bootstrap'
import { Router, Route, Switch, Link } from "react-router-dom";
import { useIdleTimer } from 'react-idle-timer'
import * as createHistory from "history";
import LoginForm from "../components/user_account/login";
import ViewOrders from "../components/orders/view_orders";
import RegisterForm from "../components/user_account/register";
import AppInfo from "../components/user_account/AppInfo";
import LoginOptions from "../components/user_account/login_option";
import ConsultationRequestForm from "../components/request_forms/consultation_request";
import ServiceRequestForm from "../components/request_forms/service_request";
import RentalRequestForm from "../components/request_forms/rental_request";
import PartsRequestForm from "../components/request_forms/parts_request";
import COIRequestForm from "../components/request_forms/coi_request";
import W9RequestForm from "../components/request_forms/w9_request";
import InvoicePaymentForm from "../components/payment/invoice_payment";
import ViewAccountsTable from "../components/payment/account_selection";
import ViewOpenInvoices from "../components/payment/open_invoices";
import ViewInvoiceHistory from "../components/payment/invoice_history";
import ViewCreditHistory from "../components/payment/credit_history";
import OpenOrders from "../components/orders/open_orders";
import BolandOpenOrders from "../components/orders/boland_open_orders";
import SchedulingRequest from "../components/request_forms/scheduling_request";
import ContractRenewalRequest from "../components/request_forms/contract_renewal_request";
import OrderInquiry from "../components/request_forms/order_inquiry_request";
import OrderSiteVisits from "../components/orders/order_site_visits";
import CustomerStatementPage from "../components/reporting/customer_statement";
import PasswordResetRequest from "../components/user_account/password_reset_request";
import ResetPasswordForm from "../components/user_account/reset_password";
import BuildingServiceView from "../components/reporting/building_service_view";
import BuildingServiceViewAdmin from "../components/reporting/building_service_view_admin";
import ManageAccounts from "../components/user_account/manage_accounts";
import PaymentConfirmation from "../components/payment/payment_confirmation";
import ViewOrderDetails from "../components/orders/view_order_details";
import OpenOrdersReport from "../components/reporting/open_orders_report";
import FeedbackForm from "../components/request_forms/feedback_form";
import GuestViewOrderDetails from "../components/guest/guest_view_order_details";
import UserManager from "../components/user_account/user_manager";
import ManageWallet from "../components/payment/manage_wallet";
import ContractorMainPage from "../components/contractor/contractor_main_page";
import ContractorLogin from "../components/contractor/contractor_login";
import ContractorNewJob from "../components/contractor/contractor_new_job";
import ContractorNotification from "../components/contractor/Contractor_Notification";
import ContractorRemoveFromBid from "../components/contractor/contractor_remove";
import ContractorAddFromBid from "../components/contractor/contractor_add";
import ContractorRegister from "../components/contractor/contractor_register";
import LandingPage from "../components/landing_page";
import BolandLandingPage from "../components/boland_landing_page";
import ServiceReportUploadForm from "../components/reporting/service_report_upload_form"; 
import ViewServiceReports from "../components/reporting/view_service_reports"; 
import ViewServiceReportsRefrigerant from "../components/reporting/view_service_reports_refrigerant";
import TrainingMain from "../components/training/training_main";
import TrainingMainTemp from "../components/training/training_main_TEMP";
import DownloadCertAdminPage from "../components/training/download_cert_admin";
import UserSettings from "../components/user_account/user_settings";
import TrainingRegistrationForm from "../components/training/training_register";
import TrainingPaymentForm from "../components/training/training_payment";
import TrainingActive from "../components/training/training_active";
import ApplyCredits from "../components/payment/apply_credits";
import ConciergeMain from "../components/request_forms/concierge_main";
import ViewServiceRequest from "../components/request_forms/view_service_request";
import ViewUnmappedLocation from "../components/request_forms/view_unmapped_location";
import ManageBuildingLocation from "../components/request_forms/Manage_Building_location";
import LocationFilter from "../components/user_account/location_filter";
import ReactGA from "react-ga4";
// Instead of BrowserRouter, we use the regular router,
// but we pass in a customer history to it.
export const history = createHistory.createBrowserHistory();
export function getTimeoutSeconds() {
    var sTO = 1800000;
    var cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith("userTimeoutSeconds="))
        ?.split("=")[1];
    if (!cookieValue) {
        //alert('Cookie Value: userTimeoutSeconds is not available');
        cookieValue = '30m'
    }
    if (cookieValue.indexOf('m') > 0) {
        sTO = parseInt(cookieValue.replace('m','')) * 60000;
    }
    else if (cookieValue.indexOf('hr') > 0) {
        sTO = parseInt(cookieValue.replace('hr','')) * 3600000;
    }
    return sTO;
}
export const AppRouter: React.FC = () => {
    interface user { username: string; };
    interface state { user: user };



    const onIdle = () => {
        try {
            if (history.location.state && ((history.location.state as state).user as user) && ((history.location.state as state).user as user).username != '') {
                history.push({
                    pathname: '/'
                });
                setShowModal(true);
            }
        }
        catch (e: unknown) {
        }
    }

    const onHide = () => {
        setShowModal(false);
    }

    const onActive = (event: Event) => {
    }

    const onAction = (event: Event) => {
    }

    const [showModal, setShowModal] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastClosed, setToastClosed] = useState(false);

    useEffect(() => {
        const unlisten =
            history.listen((location, action) => {
                if ((action == 'PUSH' || action == 'REPLACE') && location.pathname != '/contractor_login' && location.pathname != '/payment_confirmation' &&
                    (typeof location.state == 'undefined' || typeof (location.state as state).user == 'undefined') &&
                    toastClosed == false) {
                    setShowToast(true);
                }
                else if ((action == 'PUSH' || action == 'REPLACE') &&
                    (typeof location.state !== 'undefined' && typeof (location.state as state).user !== 'undefined')) {
                    setShowToast(false);

                }
                if (action == 'PUSH') {
                    //ReactGA.send({ hitType: "pageview", page: location.pathname });
                }
            });
        if (toastClosed == false &&
            history.location.pathname != '/' && history.location.pathname != '/contractor_login' && history.location.pathname != '/payment_confirmation' &&
            (!history.location.state || !((history.location.state as state).user as user) || ((history.location.state as state).user as user).username == '')) {
            setShowToast(true);
        }

        return () => {
            unlisten();
        };
    }, [history, setShowToast, setToastClosed, toastClosed, showToast]);

    const { getRemainingTime, getLastActiveTime } = useIdleTimer({
        onIdle,
        onActive,
        onAction,
        timeout: getTimeoutSeconds(),
        events: [
            'keydown',
            'wheel',
            'DOMMouseScroll',
            'mousewheel',
            'mousedown',
            'touchstart',
            'touchmove',
            'MSPointerDown'/*,
            'MSPointerMove',
            'visibilitychange'*/
        ],
        throttle: 10000
    })
    const curTime = new Date();
    return (<Router history={history}>
        <div>
            <Modal show={showModal} onHide={onHide}>
                <Modal.Header closeButton >
                    <Modal.Title>Auto Logout</Modal.Title>
                </Modal.Header>
                <Modal.Body>You have been logged out due to inactivity.
                    <p>You may go to My Profile-&gt;User Settings to change Auto Logout time. </p>
                    <p>Logout Time: {curTime.toLocaleString()}</p>
                </Modal.Body>
            </Modal>
            <Switch>
                <Route path="/" exact component={LoginForm} />
                <Route path="/orders" exact component={ViewOrders} />
                <Route path="/open_orders" exact component={OpenOrders} />
                <Route path="/boland_open_orders" exact component={BolandOpenOrders} />
                <Route path="/register" exact component={RegisterForm} />
                <Route path="/AppInfo" exact component={AppInfo} />
                <Route path="/login_option" exact component={LoginOptions} />
                <Route path="/consultation_request" exact component={ConsultationRequestForm} />
                <Route path="/service_request" exact component={ServiceRequestForm} />
                <Route path="/rental_request" exact component={RentalRequestForm} />
                <Route path="/parts_request" exact component={PartsRequestForm} />
                <Route path="/coi_request" exact component={COIRequestForm} />
                <Route path="/w9_request" exact component={W9RequestForm} />
                <Route path="/invoice_payment" exact component={InvoicePaymentForm} />
                <Route path="/account_selection" exact component={ViewAccountsTable} />
                <Route path="/open_invoices" exact component={ViewOpenInvoices} />
                <Route path="/invoice_history" exact component={ViewInvoiceHistory} />
                <Route path="/scheduling_request" exact component={SchedulingRequest} />
                <Route path="/contract_renewal_request" exact component={ContractRenewalRequest} />
                <Route path="/order_inquiry" exact component={OrderInquiry} />
                <Route path="/site_visits" exact component={OrderSiteVisits} />
                <Route path="/customer_statement" exact component={CustomerStatementPage} />
                <Route path="/forgot_password" exact component={PasswordResetRequest} />
                <Route path="/reset_password" component={ResetPasswordForm} />
                <Route path="/building_service_view" exact component={BuildingServiceView} />
                <Route path="/building_service_view_admin" exact component={BuildingServiceViewAdmin} />
                <Route path="/manage_accounts" exact component={ManageAccounts} />
                <Route path="/payment_confirmation" exact component={PaymentConfirmation} />
                <Route path="/view_order_details" exact component={ViewOrderDetails} />
                <Route path="/open_orders_report" exact component={OpenOrdersReport} />
                <Route path="/order_details_guest" exact component={GuestViewOrderDetails} />
                <Route path="/user_manager" exact component={UserManager} />
                <Route path="/feedback" exact component={FeedbackForm} />
                <Route path="/manage_wallet" exact component={ManageWallet} />
                <Route path="/contractor_portal" exact component={ContractorMainPage} />
                <Route path="/contractor_register" exact component={ContractorRegister} />
                <Route path="/contractor_login" exact component={ContractorLogin} />
                <Route path="/new_job" exact component={ContractorNewJob} />
                <Route path="/Contractor_Notification" exact component={ContractorNotification} />
                <Route path="/request_remove" exact component={ContractorRemoveFromBid} />
                <Route path="/request_add" exact component={ContractorAddFromBid} />
                <Route path="/landing_page" exact component={LandingPage} />
                <Route path="/boland_landing_page" exact component={BolandLandingPage} />
                <Route path="/service_report_upload" exact component={ServiceReportUploadForm} />
                <Route path="/predictive_reporting" exact component={ViewServiceReports} />
                <Route path="/refrigerant_reporting" exact component={ViewServiceReportsRefrigerant} />
                <Route path="/training" exact component={TrainingMainTemp} />
                <Route path="/download_cert" exact component={DownloadCertAdminPage} />
                <Route path="/user_settings" exact component={UserSettings} />
                <Route path="/training_registration" exact component={TrainingRegistrationForm} />
                <Route path="/training_payment" exact component={TrainingPaymentForm} />
                <Route path="/my_training" exact component={TrainingActive} />
                <Route path="/credit_history" exact component={ViewCreditHistory} />
                <Route path="/apply_credits" exact component={ApplyCredits} />
                <Route path="/concierge_main" exact component={ConciergeMain} />
                <Route path="/view_service_request" exact component={ViewServiceRequest} />
                <Route path="/view_unmapped_location" exact component={ViewUnmappedLocation} />
                <Route path="/Manage_Building_Location" exact component={ManageBuildingLocation} />
                <Route path="/location_filter" exact component={LocationFilter} />
                <Route path="/login_option" exact component={LoginOptions} />
            </Switch>
            <ToastContainer position='bottom-end' className="p-3 position-fixed">
                <Toast style={{ fontSize: '1rem', width:'402px' }} show={showToast} onClose={() => {
                    setToastClosed(true);
                    setShowToast(false);
                }}>
                    <Toast.Header style={{ backgroundColor: '#527ff9', fontWeight: 'bold', color:'white' }}>Login for Extra Features
                    <strong className="me-auto"/>
                    </Toast.Header>
                    <Toast.Body><Link target="_blank" to={{
                            pathname: "/register"
                        }} >Register here</Link> to access your open orders dashboard, track contract dates & maintenance visits, run building service reports, pay invoices, and more!
                        <br/>
                        <Link target="_blank" to={{
                            pathname: "/"
                        }}>Login here</Link> if you've already registered.
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </div>
    </Router>);
}